import {
  ExclusiveCategory,
  getNecoidByExclusiveCategory,
} from '@wix/da-shared-react/pkg/types/exclusives';

interface CategoryData {
  categoryKey: ExclusiveCategory;
  necoId: string;
  translationKey: string;
}

/**
 * All of our exclusive categories in display order.
 *
 * Note: These are actually topics on the backend.
 * If you need to change any or add more, you can find what you need for any topic at https://admin.deviantart.com/tools/curated/necos
 */
export const exclusiveCategoriesFormData: {
  [key in ExclusiveCategory]: CategoryData;
} = {
  [ExclusiveCategory.Adoptable]: {
    categoryKey: ExclusiveCategory.Adoptable,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.Adoptable),
    translationKey: 'sellerModal.create.exclusive_category.option.adoptable',
  },
  [ExclusiveCategory.DigitalArt]: {
    categoryKey: ExclusiveCategory.DigitalArt,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.DigitalArt),
    translationKey: 'sellerModal.create.exclusive_category.option.digitalArt',
  },
  [ExclusiveCategory.GameArt]: {
    categoryKey: ExclusiveCategory.GameArt,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.GameArt),
    translationKey: 'sellerModal.create.exclusive_category.option.gameArt',
  },
  [ExclusiveCategory.MixedMedia]: {
    categoryKey: ExclusiveCategory.MixedMedia,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.MixedMedia),
    translationKey: 'sellerModal.create.exclusive_category.option.mixedMedia',
  },
  [ExclusiveCategory.Photography]: {
    categoryKey: ExclusiveCategory.Photography,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.Photography),
    translationKey: 'sellerModal.create.exclusive_category.option.photography',
  },
  [ExclusiveCategory.Pinups]: {
    categoryKey: ExclusiveCategory.Pinups,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.Pinups),
    translationKey: 'sellerModal.create.exclusive_category.option.pinups',
  },
  [ExclusiveCategory.TraditionalArt]: {
    categoryKey: ExclusiveCategory.TraditionalArt,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.TraditionalArt),
    translationKey: 'sellerModal.create.exclusive_category.option.traditionalArt',
  },
  [ExclusiveCategory.ThreeDArt]: {
    categoryKey: ExclusiveCategory.ThreeDArt,
    necoId: getNecoidByExclusiveCategory(ExclusiveCategory.ThreeDArt),
    translationKey: 'sellerModal.create.exclusive_category.option.threeD',
  },
};
